import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { LoaderSpinner } from 'components/common/LodaerSpinner/LoaderSpinner';

import { CustomizedTooltip } from 'components/common';
import classes from 'components/widgets/RenderLibraryTable/components/ActionMenuPending/ActionMenuPending.module.scss';

interface Props {
    className?: string;
}

export const ActionMenuPending = ({ className }: Props) => {
    return (
        <CustomizedTooltip
            tooltipPosition={TooltipPosition.Bottom}
            tooltipContent={'Program processing is pending. It might take a few minutes...'}
            triggerElement={
                <div className={classes.actionMenuPending}>
                    <LoaderSpinner className={className} />
                    Uploading...
                </div>
            }
        />
    );
};
